import __var_0__ from '@stdlib/vendor/debug.js';
import __var_1__ from './lines.js';
import __var_2__ from './symbols.js';
import __var_3__ from './x_rug.js';
import __var_4__ from './y_rug.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var logger = __var_0__;
var lines = __var_1__;
var symbols = __var_2__;
var xRug = __var_3__;
var yRug = __var_4__;


// VARIABLES //

var debug = logger( 'plot:render:svg:marks' );


// MAIN //

/**
* Renders individual marks.
*
* @private
* @param {Object} state - state
* @returns {VTree} virtual tree
*/
function render( state ) {
	var parent;
	var marks;
	var len;
	var i;

	debug( 'Rendering marks group...' );
	parent = state.$.svg.marks.render();

	len = state.x.length;
	if ( len === 0 ) {
		debug( 'No individual marks to render.' );
		return parent;
	}
	marks = [];

	debug( 'Rendering lines...' );
	marks = marks.concat( lines( state ) );

	debug( 'Rendering symbols...' );
	marks = marks.concat( symbols( state ) );

	debug( 'Rendering x-axis rug plots...' );
	marks = marks.concat( xRug( state ) );

	debug( 'Rendering y-axis rug plots...' );
	marks = marks.concat( yRug( state ) );

	debug( 'Inserting individual marks into marks group...' );
	for ( i = 0; i < marks.length; i++ ) {
		parent.children.push( marks[i] );
		parent.count += marks[i].count;
	}
	debug( 'Finished rendering marks.' );
	return parent;
}


// EXPORTS //
export default render;
